"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (name, actions, mspf) {
    var max = 0;
    if (!actions) {
        return max;
    }
    for (var selector in actions) {
        for (var eventName in actions[selector]) {
            var _a = eventName.split(':'), _ = _a[0], // always "timeline"
            timelineNameOfListener = _a[1], frameKeyOfListener = _a[2];
            // Skip non-frame-listener events
            if (!timelineNameOfListener || !frameKeyOfListener) {
                continue;
            }
            // Skip frame listeners for timelines other than us
            if (timelineNameOfListener !== name) {
                continue;
            }
            var frameOfListener = Number(frameKeyOfListener);
            var timeOfListener = frameOfListener * mspf;
            if (timeOfListener > max) {
                max = timeOfListener;
            }
        }
    }
    return max;
});
//# sourceMappingURL=getActionsMaxTime.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/getActionsMaxTime.js
// module id = 125
// module chunks = 35783957827783 127651196306611 162898551421021